import { render, staticRenderFns } from "./FacultySelectboxMultiple.vue?vue&type=template&id=01f3e824"
import script from "./FacultySelectboxMultiple.vue?vue&type=script&lang=js"
export * from "./FacultySelectboxMultiple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports